// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/@vue/cli-service/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".chip-custom[data-v-4983aad9] {\n  font-size: 12px;\n  color: #ff9900;\n}[dir] .chip-custom[data-v-4983aad9] {\n  background-color: #fff5df;\n  border-radius: 10px;\n  padding: 4px 8px;\n  text-align: center;\n}[dir=ltr] .chip-custom[data-v-4983aad9] {\n  margin-left: 30px;\n}[dir=rtl] .chip-custom[data-v-4983aad9] {\n  margin-right: 30px;\n}\n", ""]);
// Exports
module.exports = exports;
